import {computed, Injectable} from '@angular/core';
import {AppConfigService} from "../../core/config/config.service";
import {
  SS_COUPONS_RELEASE_ENDPOINT,
  SS_COUPONS_VALIDATE_ENDPOINT,
  SsResult,
  SsResultStatusCode
} from "../stockstore-pos/stockstore-pos.types";
import {catchError, Observable, throwError, timeout, TimeoutError} from "rxjs";
import {HttpClient} from "@angular/common/http";
import {CouponReleaseRequest, CouponValidationRequest, CouponValidationResponse} from "./coupons.types";

/**
 * Service related to coupons features.
 */
@Injectable({
  providedIn: 'root'
})
export class CouponsService {

  ssLocalEndpoint = computed(() => {
    return AppConfigService.Config()?.endpoints?.kioskPos;
  });

  config = AppConfigService.Config;

  constructor(private httpClient: HttpClient) {
  }

  validateCoupon(dto: CouponValidationRequest): Observable<SsResult<CouponValidationResponse>> {

    //prod: this.ssLocalEndpoint() + SS_COUPONS_VALIDATE_ENDPOINT
    //mock: "http://127.0.0.1:1221/" + SS_COUPONS_VALIDATE_ENDPOINT
    return this.httpClient.post<SsResult<CouponValidationResponse>>(this.ssLocalEndpoint() + SS_COUPONS_VALIDATE_ENDPOINT, dto)
      .pipe(
        timeout(100000), //10 sec
        catchError(error => {
          if (error instanceof TimeoutError) {
            error = {
              ...error,
              error: {
                statusCode: SsResultStatusCode.ERR_SS_TIMEOUT
              }
            };
          }
          return throwError(() => error);
        })
      );
  }

  releaseCoupon(dto: CouponReleaseRequest): Observable<SsResult<void>> {

    //prod: this.ssLocalEndpoint() + SS_COUPONS_RELEASE_ENDPOINT
    //mock: "http://127.0.0.1:1221/" + SS_COUPONS_RELEASE_ENDPOINT
    return this.httpClient.post<SsResult<void>>(this.ssLocalEndpoint() + SS_COUPONS_RELEASE_ENDPOINT, dto)
      .pipe(
        timeout(100000), //10 sec
        catchError(error => {
          if (error instanceof TimeoutError) {
            error = {
              ...error,
              error: {
                statusCode: SsResultStatusCode.ERR_SS_TIMEOUT
              }
            };
          }
          return throwError(() => error);
        })
      );
  }


}
